// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import * as patientCareSuspensionAPI from 'api/patientCareSuspension';

// ----------------------------------------------------------------------

const initialState = {
    list: {
        error: null,
        loading: true,
        data: []
    },
    status: {
        // whether currently suspended
        error: null,
        loading: true,
        data: {}
    }
};

const slice = createSlice({
    name: 'patientCareSuspension',
    initialState,
    reducers: {
        setListError(state, action) {
            state.list.error = action.payload;
            state.list.loading = false;
        },
        setListData(state, action) {
            state.list.data = action.payload;
            state.list.loading = false;
            state.list.error = null;
        },
        resetList(state) {
            state.list = initialState.list;
        },
        setStatusError(state, action) {
            state.status.error = action.payload;
            state.status.loading = false;
        },
        setStatusData(state, action) {
            state.status.data = action.payload;
            state.status.loading = false;
            state.status.error = null;
        },
        resetStatus(state) {
            state.status = initialState.status;
        }
    }
});

export default slice.reducer;

export function resetList() {
    dispatch(slice.actions.resetList());
}

export function resetStatus() {
    dispatch(slice.actions.resetStatus());
}

export function getCareSuspensions(patientId) {
    return async () => {
        try {
            const response = await patientCareSuspensionAPI.listCareSuspension(patientId);
            dispatch(slice.actions.setListData(response.data.careSuspensions));
        } catch (error) {
            dispatch(slice.actions.setListError(error));
        }
    };
}

export function getSuspensionStatus(patientId) {
    return async () => {
        try {
            const response = await patientCareSuspensionAPI.getCareSuspensionStatus(patientId);
            dispatch(slice.actions.setStatusData(response.data.careSuspension));
        } catch (error) {
            dispatch(slice.actions.setStatusError(error));
        }
    };
}
